import { http } from '../util/http'
import { API_KOTLIN_DOMAIN, API_DOMAIN } from '../config'
import headers from './employeeSystemHeader'
import { fetchData, postData } from '../util/index'

// 获取权限模板列表（联盟+俱乐部）(其实这就是俱乐部调用得接口 拿联盟得模板和俱乐部自己的模板)
export const getAllTemplateList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionTemplate/all`,
  })
}

// 获取权限模板列表
export const getTemplateList = () => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionTemplate`,
  })
}

// 获取权限模板详情
export const getTemplateDetail = (templateId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionTemplate/detail`,
    params: {
      id: templateId,
    },
  })
}

// 新增或修改员工权限模板
export const addOrEditPermissionTemplate = (data) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionTemplate`,
    method: 'post',
    data,
  })
}

// 删除权限模板
export const deletePermissionTemplate = (templateId) => {
  return http({
    headers: headers(),
    url: `${API_KOTLIN_DOMAIN}/business-employee/permissionTemplate/disabled`,
    method: 'post',
    data: {
      id: templateId,
    },
  })
}

// 获取权限模板详情
export const getClubCommodity = () => {
  return fetchData(`${API_DOMAIN}/SetClubApi/UserClubList`)
}



// WEBPACK FOOTER //
// ./src/api/permissionTemplate.js